import { gql } from 'graphql-tag'
import fragmentBlockIndexContentGroup from '../block-index-content-group/fragment-block-index-content-group'

export default gql`
  ${fragmentBlockIndexContentGroup}
  fragment BlockIndexChapterFragment on BlockIndexChapter {
    sys {
      id
    }
    title
    contentType: __typename
    navigationTitle
    contentGroupsCollection {
      items {
        ...BlockIndexContentGroupFragment
      }
    }
  }
`
